import React from "react";
import { Grid } from "@mui/material";
import SubHeader from "components/subHeader/SubHeader";
import CustomerCarousel from "./CustomerCarousel";

function CustomerHeader(props) {
  const emergencyTrue =
    props?.tableData?.DemandProfile?.EmergencyContacts?.length > 0
      ? true
      : false;
  return (
    <div>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        className={`profilevendorMain ${emergencyTrue ? "marginBottom0" : ""}`}
      >
        <SubHeader
          details={props?.tableData}
          tabName={props?.tabName}
          onClickStatusIcon={props?.onClickStatusIcon}
          loader={props?.loader}
        />
        <CustomerCarousel details={props?.tableData} loader={props?.loader} />
      </Grid>
    </div>
  );
}

export default CustomerHeader;
